import React from 'react';
import './index.scss';
export default function Description(props: any) {
  const { desc, noDataTip } = props;

  return (
    <div className="dbi-description-context">
      {desc ? <div
        className="intelligence-desc"
        dangerouslySetInnerHTML={{ __html: desc }}
      ></div> : <div className="nodata-center-des">{noDataTip}</div>}
    </div>
  );
}
